import YesNo from './YesNo.vue';

export default YesNo;
